import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { SHOP } from "../data/shop";
import "./Stream.css";

declare global {
  interface Window {
    Twitch: any;
  }
}

const EMBED_SRC = "https://embed.twitch.tv/embed/v1.js";

export const Stream = () => {
  useEffect(() => {
    const mount = () => {
      const target = document.getElementById("twitch");
      if (!window.Twitch || !target || target.childElementCount > 0) return;

      new window.Twitch.Embed("twitch", {
        autoplay: false,
        channel: SHOP.twitchChannel,
        height: "100%",
        layout: "video",
        theme: "dark",
        width: "100%",
      });
    };

    // The script only needs to load once, even across remounts.
    const existing = document.querySelector<HTMLScriptElement>(
      `script[src="${EMBED_SRC}"]`
    );

    if (existing) {
      if (window.Twitch) mount();
      else existing.addEventListener("load", mount);
      return () => existing.removeEventListener("load", mount);
    }

    const script = document.createElement("script");
    script.src = EMBED_SRC;
    script.addEventListener("load", mount);
    document.body.appendChild(script);

    return () => script.removeEventListener("load", mount);
  }, []);

  return (
    <section id="live" className="stream">
      <Container>
        <div className="section-head">
          <span className="eyebrow">Live from the Shop</span>
          <h2 className="section-title gold-text">In the Chair</h2>
          <p className="lede mx-auto mt-3">
            When the stream is live you can see how busy we are before you head
            over, and how many people are waiting for a chair.
          </p>
          <div className="rule">
            <span className="diamond" />
          </div>
        </div>

        <div className="stream__panel frame">
          <div className="stream__bar">
            <span className="stream__light" />
            <span className="stream__channel">
              twitch.tv/{SHOP.twitchChannel}
            </span>
          </div>
          <div className="video">
            <div id="twitch" />
          </div>
        </div>
      </Container>
    </section>
  );
};
